export const SHOW_SIDEBAR = 'show_sidebar';
